export function formatearFechaCorta(fechaStr: string) {
  const mesesCortos = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
  const [year, month, day] = fechaStr.split('-').map(Number);
  const fecha = new Date(year, month - 1, day);
  return `${fecha.getDate()} ${mesesCortos[fecha.getMonth()]}, ${fecha.getFullYear()}`;
}

export function formatearFechaLarga(fechaStr: string, { monthAtStart = false }: {monthAtStart?: boolean} = {}) {
  const mesesLargos = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
  ];
  const [year, month, day] = fechaStr.split('-').map(Number);
  const fecha = new Date(year, month - 1, day);
  return `${monthAtStart ? mesesLargos[fecha.getMonth()] + ' ' : ''}${fecha.getDate()}${monthAtStart ? '' : ' ' + mesesLargos[fecha.getMonth()]}, ${fecha.getFullYear()}`;
}